import { SectionWithListPageSchema } from 'cms/schemaTypes/staticPages/documents/sectionList'
import { TextItemSchema } from 'cms/schemaTypes/staticPages/objects/textItem'

import CustomPortableText from 'lib/sanity/richText/CustomPortableText'
import ExpandablePanel from 'shared/ui/ExpandablePanel'
import FormattedText from 'shared/ui/FormattedText'

import { SectionContainer, SectionContent } from '../landings/styles'

import styles from './FaqContent.module.scss'

interface FaqContentProps {
  header: string
  intro: TextItemSchema
  questionsGroups: SectionWithListPageSchema[]
}

const FaqContent = ({ header, questionsGroups, intro }: FaqContentProps) => {
  return (
    <SectionContainer $condensed>
      <SectionContent $top={3} $topMobile={3} $bottom={12} $bottomMobile={12}>
        <div className={styles.wrapper}>
          <h1 className={styles.header}>
            <FormattedText text={header} />
          </h1>
          <div className={styles.headerContent}>
            <CustomPortableText value={intro.textField} />
          </div>
          {questionsGroups.map(
            ({ key, header: sectionHeader, sectionList }) => (
              <div key={key} className={styles.paragraphWrapper}>
                <div className={styles.paragraphTitle}>{sectionHeader}</div>
                {sectionList.map(
                  (
                    {
                      key: sectionListKey,
                      header: sectionListHeader,
                      content: sectionListContent
                    },
                    index
                  ) => (
                    <ExpandablePanel
                      key={sectionListKey}
                      title={`${index + 1}. ${sectionListHeader}`}
                      id={`faq-${key}-${sectionListKey}`}
                    >
                      <CustomPortableText value={sectionListContent || []} />
                    </ExpandablePanel>
                  )
                )}
              </div>
            )
          )}
        </div>
      </SectionContent>
    </SectionContainer>
  )
}

export default FaqContent
